import { notNullOrUndefined } from "@equiem/web-ng-lib";
import React from "react";
import { RegisterNow } from ".";
import { PublicContentViewQuery } from "../../generated/gateway-client";
import { arrayNotEmpty } from "../../lib/arrayNotEmpty";
import { ContentType } from "../../lib/ContentType";
import { PostContent } from "../PostContent";
import { PostContentPage } from "../PostContentPage";

type BuildingInfoPost = PublicContentViewQuery["publicContentView"]["node"] & {
  __typename: "BuildingInfoPost";
};

interface Props {
  post: BuildingInfoPost;
}

export const BuildingInfoPost: React.FC<Props> = ({ post }) => (
  <>
    <PostContentPage
      uuid={post.uuid}
      contentType={ContentType.BuildingInfoPost}
      title={post.title}
      images={[post.featuredImage.url].filter(notNullOrUndefined)}
      commentsEnabled={false}
      enableEntityViewMetric={false}
      pageMetricName="anonymous_page_view"
      actions={null}
      downloads={arrayNotEmpty(post.downloads) ? post.downloads : undefined}
      relatedInformation={
        arrayNotEmpty(post.relatedInfo) ? post.relatedInfo : undefined
      }
    >
      <PostContent html={post.body} className="mt-3" />
    </PostContentPage>
    <RegisterNow />
  </>
);
